<template>
  <div>
    <div :class="{ hide: !firstLoad }">
      <slot name="initial-articles"></slot>
    </div>
    <div class="article-grid-container" :class="{ hide: firstLoad }">
      <ul class="article-grid" :class="{'article-grid--transparent': transparent}">
        <li v-for="(article, i) in currentArticles" :key="i" v-tag:useractionevent='{ name:"select_article",click_area:"content",articlename:"@article.title"}'>
          <a
            :href="article.url"
            class="card article-card"
            :id="`article-card--${i}`"
          >
            <div class="article-card__image">
              <img
                class="lazyload"
                :alt="article.imgAlt"
                height="179"
                :data-src="article.imgLazy"
                width="146"
              />
            </div>
            <div class="article-card__content">
              <div class="article-card__title" v-ellipsis="50">
                {{ article.title }}
              </div>
              <div class="article-card__text" v-ellipsis="50">
                {{ article.text }}
              </div>
              <div class="article-card__datetime" v-if="hideDate" />
              <div class="article-card__datetime" v-else>
                {{ article.datetime }}
              </div>
            </div>
            <div class="debug-info">
              {{ article.debug_info }}
            </div>
          </a>
        </li>
      </ul>
      <div
        :class="[
          'article-grid-container__loading',
          { 'article-grid-container__loading--show': loading },
        ]"
      >
        <div v-if="loading">
          <span class="is-sr-only">{{ loadingStateLabel }}</span>
          <slot name="loading-animation" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ellipsis } from "@Foundation/directives/ellipsis/ellipsis";
  import { srcset } from "@Foundation/directives/srcset/srcset";
  import { eventBus } from "@Foundation/eventbus/eventbus";

  export default {
    name: "dynamic-article-grid",
    directives: {
      ellipsis,
      srcset,
    },
    props: {
      apiUrl: {
        type: String,
        required: true,
      },
      loadingStateLabel: {
        type: String,
        required: false,
        default: "Loading more results",
      },
      hideDate: {
        type: Boolean,
        required: false,
        default: false,
      },
      transparent: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        currentArticles: [],
        loading: false,
        url: "",
        baseUrl: "",
        firstLoad: true,
        firstLoadedCard: null,
      };
    },
    created() {
      console.log("tulio", this.transparent, this.loadingStateLabel);
      this.url = this.apiUrl;
      this.baseUrl = this.apiUrl;
      eventBus.$on("search-filters-change", (filtersAndSort) => {
        this.applyFiltersToUrl(filtersAndSort);
      });
    },
    methods: {
      loadArticles() {
        this.currentArticles = [];
        this.loading = true;
        this.firstLoad = false;
        const parseJSON = (response) => response.json();
        fetch(this.url)
          .then(parseJSON)
          .then((data) => {
            this.currentArticles = this.currentArticles.concat(data.articles);
            this.firstLoadedCard = data.articles[0].url;
            this.loading = false;
            eventBus.$emit("articles-loaded", {
              newUrl: data.newUrl,
              hasMore: data.hasMore,
            });

            this.$nextTick(() => {
              this.focusOnFirstLoadedCard();
            });
          })
          .catch((error) => {
            this.loading = false;
          });
      },

      focusOnFirstLoadedCard() {
        const card = document.querySelector(`a[href="${this.firstLoadedCard}"`);

        if (card) {
          card.focus();
        }
      },

      applyFiltersToUrl(filtersAndSort) {
        this.filters = filtersAndSort.filters;
        this.sort = filtersAndSort.sort;
        this.url = this.baseUrl;

        if (this.sort) {
          this.url = this.url.concat(`&sort=${this.sort}`);
        }
        if (this.filters.length > 0) {
          this.filters.forEach((filter) => {
            this.url = this.url.concat(`&${filter.key}=${filter.value}`);
          });
        }

        this.loadArticles();
      },
    },
  };
</script>

<style src="./DynamicArticleGrid.scss" lang="scss">
